<template>
  <div class="card">
    <header class="card-header">
      <p class="card-header-title">
        <span><b-icon icon="export" size="is-small"> </b-icon></span>
        <span style="margin-left: 10px"> Solicitud de recojo</span>
      </p>
    </header>

    <div class="card-content">
      <div class="content">
        <b-field label="Lista de Materiales">
          <b-table
            :data="materiales"
            :bordered="false"
            :striped="true"
            :narrowed="true"
            :hoverable="true"
            :loading="false"
            :mobile-cards="true"
            :sortable="false"
          >
            <template slot-scope="props">
              <b-table-column>
                {{ props.row.code }}
              </b-table-column>
            </template>

            <template slot="empty">
              <section class="section">
                <div class="content has-text-grey has-text-centered">
                  <p>
                    <b-icon icon="emoticon-sad" size="is-large"> </b-icon>
                  </p>
                  <p>No hay Materiales agregados.</p>
                </div>
              </section>
            </template>
          </b-table>
        </b-field>

        <br />

        <div class="columns is-multiline">
          <div class="column is-6">
            <b-field label="Fecha de recojo">
              <b-datepicker
                placeholder="Ingresa la fecha de recojo"
                icon="calendar-today"
                :readonly="false"
                :min-date="minDate"
                v-model="pickupDate"
              >
              </b-datepicker>
            </b-field>
          </div>

          <div class="column is-6">
            <b-field label="Hora de recojo">
              <b-timepicker
                placeholder="Ingresa la hora de recojo"
                icon="clock"
                :readonly="false"
                v-model="pickupHour"
              >
              </b-timepicker>
            </b-field>
          </div>

          <div class="column is-6">
            <b-field label="Responsable" expanded>
              <p class="subtitle is-6">{{ responsable }}</p>
            </b-field>
          </div>

          <div class="column is-6">
            <b-field label="Comentario" expanded>
              <b-input v-model="comment"></b-input>
            </b-field>
          </div>

          <!-- <div class="column is-12">
            <b-field label="Dirección de recojo" expanded>
              <b-autocomplete
                v-model="pickupAddress"
                placeholder="Ej. Calle Dean Valvidia 148"
                :open-on-focus="true"
                :data="addressList"
                @select="(option) => (pickupAddress = option)"
              >
              </b-autocomplete>
              <b-input v-model="deliveryAddress"></b-input>
            </b-field>
          </div> -->


        </div>
      </div>
    </div>

    <section class="modal-card-foot is-centered">
      <button
        @click="registerPickup"
        :disabled="!validateFormPickup"
        class="button is-success"
      >
        Registrar recojo
      </button>
    </section>
  </div>
</template>

<script>

import Util from "../util";
import RecojoMateriales from "../api/modules/RecojoMateriales";

export default {
  props: ["materiales", "cargarPedidos"],
  data() {
    const today = new Date();
    return {
      responsable: null,
      minDate: new Date(today.getFullYear(), today.getMonth(), today.getDate()),
      pickupDate: new Date(),
      pickupHour: null,
      comment: null,
      pickupAddress: null,
      addressList: [],
    };
  },
  computed: {
    validateFormPickup() {
      if (
        this.materiales.length == 0 ||
        this.pickupDate == null ||
        this.pickupHour == null
      ) {
        return false;
      } else {
        return true;
      }
    },
  },
  methods: {
    registerPickup() {
      //Seteo Hora a la fecha
      this.pickupDate.setHours(this.pickupHour.getHours());
      this.pickupDate.setMinutes(this.pickupHour.getMinutes());

      let idAddress = Util.getUser().idAddress;

      let pickup = {
        idClient: Util.getAuth().idClient,
        idUser: Util.getAuth().idUser,
        userName: Util.getAuth().name,
        comment: this.comment,
        pickupDate: this.pickupDate,
        materiales: this.materiales,
      };

       return new Promise((resolve, reject) => {
        RecojoMateriales.saveItemMaterial(this, {
          pickup,
          idClient: Util.getAuth().idClient,
          idAddress,
        })
          .then((data) => {
           this.cargarPedidos()
           this.$emit("close");
           this.$toast.open({message:"Solicitud de recojo generado correctamente",type:"is-success"});
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
  created() {
    this.responsable = Util.getAuth().name;
    this.addressList = Util.getClientAddress();

    //Seteo a las 4 pm la hora de entrega
    let hour = new Date();
    hour.setHours(16);
    hour.setMinutes(30);
    this.pickupHour = hour;
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/CarritoPickupMateriales.vue